import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import theme from '../../themes/main';

export const ResultsContainer = styled.div`
  align-items: center;
  border-radius: 4px;
  background: white;
  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  border: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 2rem 0;
  outline: 0;
  padding: 2rem;
  position: relative;
  width: 80%;

  ${breakpoint('tablet')`
    width: 60%;
  `}
`;

export const Title = styled.h2`
  margin-top: 2rem;
  color: ${theme.palette.green};

  ${breakpoint('tablet')`
    margin-top: 1rem;
  `}
`;

export const ResultItem = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;

  &.invoice {
    margin-top: 2rem;
  }
  &.invoice,
  &.invoice-date {
    margin-bottom: 1rem;
  }
  &.total {
    margin-bottom: 2rem;
  }

  ${breakpoint('tablet')`
    align-items: center;
    flex-direction: row;
    justify-content: 'center';
    width: initial;
  `}
`;

export const Label = styled.span`
  font-weight: 600;
  margin-right: 0.5rem;
`;



// WEBPACK FOOTER //
// ./src/components/Results/styledComponents.js